export const UPDATE_SELECTED_CONTACT_REQUEST = 'UPDATE_SELECTED_CONTACT_REQUEST';
export const UPDATE_SELECTED_CONTACT_SUCCESS = 'UPDATE_SELECTED_CONTACT_SUCCESS';
export const UPDATE_SELECTED_CONTACT_FAILED = 'UPDATE_SELECTED_CONTACT_FAILED';

export const CLEAR_SELECTED_CONTACT_REQUEST = 'CLEAR_SELECTED_CONTACT_REQUEST';
export const CLEAR_SELECTED_CONTACT_SUCCESS = 'CLEAR_SELECTED_CONTACT_SUCCESS';
export const CLEAR_SELECTED_CONTACT_FAILED = 'CLEAR_SELECTED_CONTACT_FAILED';